import { connect } from 'react-redux';
import View from './SchoolYearsView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import educationDurationYearsSelector from './SchoolYearsSelector';
import {
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  updateWhatIfsData,
  planImpact,
} from '../../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  impactSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  educationDurationYears: educationDurationYearsSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(initialPlanImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(planImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(
      clientId,
      fpId,
      goalId,
      RouteDictionary[whatIfType],
      whatIfType,
    ));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(applyWhatIf(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
